webpackJsonp([86532353062146],{

/***/ 485:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Gatsby Starter Blog","author":"Kyle Mathews"}},"markdownRemark":{"id":"/opt/build/repo/src/pages/2017-11-16-wod/index.md absPath of file >>> MarkdownRemark","html":"<h2>Thursday 11/16</h2>\n<p>15 dumbbell deadlifts\n8 pull-ups</p>\n<p>18 dumbbell deadlifts\n8 pull-ups</p>\n<p>21 dumbbell deadlifts\n8 pull-ups</p>\n<p>24 dumbbell deadlifts\n8 pull-ups</p>\n<p>Use two 40 lbs dumbbells. Scale pull-ups to heaviest that you can complete during the course of this workout.</p>","frontmatter":{"title":"WOD 11.16.2017","date":"November 16, 2017"}}},"pathContext":{"path":"/wod-2017-11-16/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---wod-2017-11-16-b8f015644876c15b0e0f.js